import Fetch from '../../../utils/fetch';
import { settings } from '../../../settings';
import { Order, Region } from '../../../types/orderTypes';

export enum NodeType {
  RETAILER = 'RETAILER',
  HUB = 'HUB',
  LASTMILE = 'LASTMILE',
  PICKUP = 'PICKUP',
}

export enum LegStatus {
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
}

export interface Leg {
  originRegion: Region;
  originNodeType: NodeType;
  destinationRegion: Region;
  destinationNodeType: NodeType;
  departureDate: string;
  arrivalDate: string;
  status: LegStatus;
  legIndex: number;
  id: number;
}

export interface JourneyOrder {
  order: Order;
  journey: Leg[];
}

export const fetchJourneyOrder = async (
  orderId: string
): Promise<JourneyOrder | undefined> => {
  try {
    const response = await Fetch.get({
      url: `${settings.newApiUrl}/order/${orderId}/journey`,
    });
    //TODO: Error
    if (!response.ok) {
      return undefined;
    }
    return response.json();
  } catch (e) {
    console.log('Error fetching capacity info', e);
    return undefined;
  }
};

export const fetchDelayedJourneys = async (
  fromOrderId?: string
): Promise<JourneyOrder[]> => {
  const queryParam = fromOrderId ? `?fromOrderId=${fromOrderId}` : '';
  try {
    const response = await Fetch.get({
      url: `${settings.newApiUrl}/order/journey/delays${queryParam}`,
    });
    //TODO: Error
    if (!response.ok) {
      return [];
    }
    return response.json();
  } catch (e) {
    console.log('Error fetching capacity info', e);
    return [];
  }
};
